(function() {
    'use strict';

    angular
        .module('completeAir')
        .controller('revenueProductionConnectionSsrCtrl', revenueProductionConnectionSsrCtrl);

    revenueProductionConnectionSsrCtrl.$inject = ['$stateParams', 'linkService','tabRevenue','connections','datePickerService',
        '$timeout','ssrS','classifications','$uibModal','revenueProductionService'];

    function revenueProductionConnectionSsrCtrl($stateParams, linkService, tabRevenue, connections, datePickerService,
                                             $timeout,ssrS,classifications,$uibModal,revenueProductionService) {
        var vm = this;
        vm.linkService = linkService;
        vm.$uibModal = $uibModal;
        vm.tabs = tabRevenue;
        vm.connections = connections;
        vm.ssrS = ssrS;
        vm.searchFrom = {
            'classification': ""
        };
        vm.classifications = (classifications.data._embedded?classifications.data._embedded.ssrClassifications:[]);
        for(var c=0; c < vm.classifications.length; c++){
            if($stateParams.classificationSsrId!="") {
                if (linkService.getLinkId(vm.classifications[c]._links.self.href) == $stateParams.classificationSsrId) {
                    vm.searchFrom.classification = vm.classifications[c];
                }
            }
        }
        vm.editIndexX = -1;

        vm.dateConnection = {
            'departureDate': ($stateParams.departureDate != "") ? new Date(parseInt($stateParams.departureDate)) : new Date()
        };
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false
            },
            closed: function(args) {
                if(args.closeDate != ""){
                    // vm.changeDaySsr();
                }
            }
        };
        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        };
        vm.changeDaySsr = function(){
            $timeout(function(){
                var date = vm.dateConnection.departureDate;
                if(date != undefined){
                    var dateTime = date.getTime();
                    linkService.reloadRoute(linkService.getCurrentRouteName(), {departureDate: dateTime})
                }
            }, 100);
        };
        for(var i=0; i<vm.connections.length; i++){
            vm.connections[i].segmentClasses = [];
            vm.connections[i].disabledClass = true;
            vm.connections[i].disabledEdit = false;
            vm.connections[i].showEdit = true;
            vm.connections[i].showSave = false;
            for(var cl=0; cl<ssrS.length; cl++){
                var classId = linkService.getLinkId(ssrS[cl]._links.self.href);
                var indexClass = getIndexClass(classId,vm.connections[i]._embedded.segmentflights[0]._embedded.segmentSsrs);
                vm.connections[i].segmentClasses.push(
                    {
                        "segmentClassId": parseInt(vm.linkService.getLinkId(vm.connections[i]._embedded.segmentflights[0]._embedded.segmentSsrs[indexClass]._links.self.href)),
                        "classId": classId,
                        "value": vm.connections[i]._embedded.segmentflights[0]._embedded.segmentSsrs[indexClass].allowedQuantity,
                        "allowedQuantity": vm.connections[i]._embedded.segmentflights[0]._embedded.segmentSsrs[indexClass].allowedQuantity,
                        "active": vm.connections[i]._embedded.segmentflights[0]._embedded.segmentSsrs[indexClass].active,
                        "segmentFlightId": parseInt(vm.linkService.getLinkId(vm.connections[i]._embedded.segmentflights[0]._links.self.href)),
                        "takeOffCapacity": parseInt(vm.connections[i]._embedded.segmentflights[0]._embedded.segmentFlightSsr.allowedQuantity)
                    }
                );
            }
        }

        vm.searchProductionConnectionSsr = function (isValid, searchForm) {
            var date = vm.dateConnection.departureDate;
            if(date != undefined && searchForm.classification) {
                var classificationId = linkService.getLinkId(searchForm.classification._links.self.href);
                var dateTime = date.getTime();
                linkService.reloadRoute(linkService.getCurrentRouteName(), {departureDate: dateTime, classificationSsrId: classificationId})
            }
        };

        vm.editSegmentClassesSsr = function (indexX) {
            if (vm.editIndexX == indexX || vm.editIndexX == -1) {
                vm.connections[indexX].disabledClass = false;
                vm.connections[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxSegments = angular.copy(vm.connections[indexX]._embedded.segmentflights[0]._embedded.segmentSsrs);
            }
        };

        vm.cancelSegmentClassesSsr = function (indexX) {
            vm.connections[indexX]._embedded.segmentflights[0]._embedded.segmentSsrs = angular.copy(vm.auxSegments);
            vm.connections[indexX].disabledClass = true;
            vm.connections[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.auxSegments = [];
        };

        vm.saveSegmentClassesSsr = function (valid, indexX) {
            var save = [];
            if (valid) {
                for (var i = 0; i < vm.connections[0]._embedded.segmentflights[0]._embedded.segmentSsrs.length; i++) {
                    var saveObj = {
                        "allowedQuantity": vm.connections[0]._embedded.segmentflights[0]._embedded.segmentFlightSsr.allowedQuantity,
                        "segmentFlightId": vm.connections[0].segmentClasses[0].segmentFlightId, /*parseInt(vm.itineraryFlights[i].segments[j].segmentFlightId),*/
                        "segmentFlightSsrId": parseInt(linkService.getLinkId(vm.connections[0]._embedded.segmentflights[0]._embedded.segmentFlightSsr._links.self.href)), /* parseInt(vm.itineraryFlights[i].segments[j].ssrId),*/
                        "rbcSegmentSsrs": [
                            {
                                "allowedQuantity": parseInt(vm.connections[0]._embedded.segmentflights[0]._embedded.segmentSsrs[i].allowedQuantity),
                                "segmentSsrId": parseInt(linkService.getLinkId(vm.connections[0]._embedded.segmentflights[0]._embedded.segmentSsrs[i]._links.self.href))
                            }
                        ]
                    };
                    save.push(saveObj);
                }
                revenueProductionService.updateSegmentItinerariesConnectionSsr(save).then(function (res) {
                        if (res != "ok") {
                            vm.connections[indexX].segmentClasses = angular.copy(vm.auxSegments);
                        }
                        vm.connections[indexX].disabledClass = true;
                        vm.connections[indexX].showEdit = true;
                        vm.editIndexX = -1;
                        vm.auxSegments = [];
                });
            }
        }
    }

    function getIndexClass(classId,segmentClass){
        var res = 0;
        if(segmentClass != undefined) {
            for (var i = 0; i < segmentClass.length; i++) {
                if (segmentClass[i].classId == classId) {
                    res = i;
                    break;
                }
            }
        }
        return res;
    }
})();
